<template>
  <v-container fluid>
    <!-- HEADER -->
    <v-card class="mb-4 pa-4" elevation="2">
      <v-row align="center" justify="space-between">
        <v-col cols="12" md="6">
          <div class="text-h5 font-weight-bold">
            Transactions
          </div>
          <div v-if="consumerName" class="subtitle-1 grey--text text--darken-1 mt-1">
            {{ consumerName }}
          </div>

          <v-chip class="mt-2" color="primary" dark label>
            Receipt #{{ consumerLoanId }}
          </v-chip>
        </v-col>

        <v-col cols="12" md="6" class="d-flex justify-end">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="grey darken-1"
                dark
                v-bind="attrs"
                v-on="on"
                @click="goBack"
              >
                <v-icon left>
                  mdi-arrow-left
                </v-icon>
                Back
              </v-btn>
            </template>
            <span>Go to Previous Page</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card>

    <!-- MAIN CONTENT -->
    <v-row>
      <!-- ADD TRANSACTION -->
      <v-col
        v-if="authPermissions.has('consumer_loans:create')"
        lg="4"
        cols="12"
      >
        <v-card elevation="2">
          <v-toolbar flat color="primary" dark>
            <v-icon left>
              mdi-plus-circle
            </v-icon>
            Add Transaction
          </v-toolbar>

          <v-card-text>
            <create-consumer-loan-transaction
              :prop-consumer-id="consumerId"
              :prop-consumer-loan-id="consumerLoanId"
            />
          </v-card-text>
        </v-card>
      </v-col>

      <!-- LIST TRANSACTIONS -->
      <v-col lg="8" cols="12">
        <v-card elevation="2">
          <v-toolbar flat color="primary" dark>
            <v-icon left>
              mdi-format-list-bulleted
            </v-icon>
            Transactions
          </v-toolbar>

          <v-card-text>
            <index-consumer-loan-transaction
              :prop-consumer-id="consumerId"
              :prop-consumer-loan-id="consumerLoanId"
              @edit="initEditTransaction"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- EDIT DIALOG -->
    <v-dialog v-model="editTransaction" max-width="600px" persistent>
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-icon left>
            mdi-pencil
          </v-icon>
          Edit Transaction
          <v-spacer />
          <v-btn icon @click="editTransaction = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <edit-consumer-loan-transaction
            :prop-consumer-id="consumerId"
            :prop-consumer-loan-id="consumerLoanId"
            :prop-consumer-loan-transaction="consumerLoanTransaction"
            @close-dialog="editTransaction = false"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<style scoped>
.v-card {
  border-radius: 12px;
}

.text-h5 {
  letter-spacing: 0.5px;
}
</style>
<script>
import { mapState } from 'vuex'
import consumerRepository from '@/repositories/consumer.repository'
export default {
  name: 'ConsumerLoanTransaction',
  components: {
    indexConsumerLoanTransaction: () =>
      import('@/views/dashboard/components/consumer-loan-transactions/Index'),
    editConsumerLoanTransaction: () =>
      import('@/views/dashboard/components/consumer-loan-transactions/Edit'),
    createConsumerLoanTransaction: () =>
      import('@/views/dashboard/components/consumer-loan-transactions/Create'),
  },
  data() {
    return {
      consumerId: this.$route.params.consumer,
      consumerLoanId: this.$route.params.consumerLoan,
      consumerName: '',
      editTransaction: false,
      consumerLoanTransaction: {},
    }
  },
  created() {
    consumerRepository.show(this.consumerId).then(({ data }) => {
      this.consumerName = data.name
    })
  },
  computed: {
    ...mapState({
      authPermissions: (state) => state.auth.userPermissions,
    }),
  },
  methods: {
    initEditTransaction(data) {
      this.consumerLoanTransaction = data
      this.editTransaction = true
    },
    goBack() {
      const to = this.$route.query.callback ?? -1
      console.log({ to })
      if (to !== -1) {
        this.$router.push(to)
        return
      }
      this.$router.go(-1)
    },
  },
}
</script>
